export default __webpack_public_path__ + "78a276f83941c8f5cd0e7dc21e9853e5.glb";